import React, { ReactNode } from 'react';

interface DataTableDataProps {
  children: ReactNode;
}

const DataTableCell: React.FC<DataTableDataProps> = ({ children }) => {
  return <td className='px-2 text-left'>{children}</td>;
};

export default DataTableCell;
